import React from 'react'
import { Text, Format, InlineTextLock } from 'src/Components'

export default (currency, color = 'green', locked = false) => (
  <Text element='span' color={color} nowrap>
    <Format.Currency>
      <InlineTextLock enabled={locked}>
        {Format.number(Math.round(currency))}
      </InlineTextLock>
    </Format.Currency>
  </Text>
)
